import React, { useState } from "react";
import { Shield, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Link } from "react-router-dom";
import logo from "../assets/logo2.png";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white/90 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="relative">
            <img
              src={logo}
              alt="Logo"
              className="h-10 w-10 object-contain transition-transform hover:scale-105"
            />
            {/* <div className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full animate-pulse"></div> */}
          </div>
          <div>
            <span className="text-xl font-extrabold bg-gradient-to-r bg-blue-600 bg-clip-text text-transparent">
              Fastag Tracking
            </span>
            <p className="text-[10px] text-gray-400 font-semibold tracking-wide uppercase">
              Professional Fleet Solutions
            </p>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-10">
          <a
            href="/"
            className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide transition-all duration-200 hover:translate-y-[-2px]"
          >
            Home
          </a>
          <a
            href="#services"
            className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide transition-all duration-200 hover:translate-y-[-2px]"
          >
            Services
          </a>

          <a
            href="#contact"
            className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide transition-all duration-200 hover:translate-y-[-2px]"
          >
            Contact
          </a>
          <Link
            to="/privacy-policy"
            className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide transition-all duration-200 hover:translate-y-[-2px]"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide transition-all duration-200 hover:translate-y-[-2px]"
          >
            Terms and Conditions
          </Link>
          <Link to="/pricing">
            <Button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 text-sm font-semibold">
              Pricing
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <Sheet>
          <SheetTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden text-gray-600 hover:text-blue-600 hover:bg-gray-100"
              onClick={toggleMobileMenu}
            >
              <Menu className="h-6 w-6" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="w-[240px] bg-white/95 backdrop-blur-md"
          >
            <div className="flex flex-col space-y-4 mt-6">
              <a
                href="/"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                Home
              </a>
              <a
                href="#services"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                Services
              </a>
              <Link
                to="/about"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                About Us
              </Link>
              <a
                href="#contact"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                Contact
              </a>
              <Link
                to="/privacy-policy"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-and-conditions"
                className="text-gray-700 hover:text-blue-600 font-medium text-sm uppercase tracking-wide py-2"
                onClick={toggleMobileMenu}
              >
                Terms and Conditions
              </Link>
              <Link to="/pricing" onClick={toggleMobileMenu}>
                <Button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-full shadow-md w-full text-sm font-semibold">
                  Pricing
                </Button>
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
};

export default Header;